module.exports = __webpack_public_path__ + "static/media/close2.cd7b8415.svg";